import apiClient, { unwrapData } from "./apiClient";

export async function getNotifications(params = {}, options = {}) {
  const response = await apiClient.get("/api/notifications", {
    ...options,
    query: {
      limit: params.limit,
    },
  });
  const data = unwrapData(response) || {};

  return {
    unread_count: Number(data.unread_count || 0),
    items: Array.isArray(data.items) ? data.items : [],
  };
}
